import {all, fork} from 'redux-saga/effects';
import provideKeycloakTokenToServicesFlow from './sagas/provideKeycloakTokenToServicesFlow';
import provideArcGISTokenToServicesFlow from './sagas/provideArcGISTokenToServicesFlow';
import errorMessageModalFlow from './sagas/errorMessageModalFlow';
import successMessageFlow from './sagas/successMessageFlow';
import warningMessageFlow from './sagas/warningMessageFlow';
import resetListResults from './sagas/resetListResults';

const applicationWatcher = function* applicationWatcher() {
    yield all([
        fork(provideKeycloakTokenToServicesFlow),
        fork(provideArcGISTokenToServicesFlow),
        fork(errorMessageModalFlow),
        fork(successMessageFlow),
        fork(warningMessageFlow),
        fork(resetListResults),
    ]);
};

export default applicationWatcher;
